<ng-container
    *ngFor="let groupedActor of actionsByPerson; int let i = index; let firstitem = first; let lastitem = last;">
    <li class="list-group-item d-block pt-0 pe-0 pb-0 ps-2 subtable grouped" [ngClass]="{'pb-2': lastitem, 'no-header-bottom-border': !lastitem, 'lastItem': lastItemOfPersonsInSendgroup}" >
        <desktop-request-status-sendgroup-action-row [actorInSendgroup]="groupedActor"[index]="i" [itemGrouped]="true" ></desktop-request-status-sendgroup-action-row>
    </li>
</ng-container>